import { iconHighSmall, iconLowSmall, iconMedium } from "../Icons/icons";
import { useEffect, useRef, useState } from "react";

import { getSpotSeason } from "../Helpers/filters";
import useLeaflet from "../hooks/useLeaflet";

const L: any = require("leaflet");
L.esri = require("esri-leaflet");

const featureServerURL =
  "https://services-eu1.arcgis.com/1PSnmNDZsplHdhAh/ArcGIS/rest/services/Hav%c3%b8rred_Limfjorden___opdatering_af_kort_2023/FeatureServer/3";

/*
 * This component displays the fiskespots on the map
 */

const Fiskespots = (props) => {
  const [loaded, setLoaded] = useState(false);

  const context = useLeaflet();

  const layerRef = useRef(
    L.esri.featureLayer({
      //pladser fra gis
      url: featureServerURL,
      pointToLayer(_feature, latlng) {
        const layer = new L.Marker(latlng, {
          icon: iconLowSmall,
        });
        return layer;
      },
    })
  );

  useEffect(() => {
    if (!loaded) return;

    const onClick = (e) => {
      const layer = e.layer;
      props.onClick && props.onClick(layer);
    };

    layerRef.current.on("click", onClick);

    return () => {
      layerRef.current.off("click", onClick);
    };
  }, [props.onClick, loaded]);

  useEffect(() => {
    if (!loaded) return;
    function getIcon(feature) {
      //if not future mode return icon based on if spot is in filtered spots
      if (!props.futureDate) {
        return props.filteredSpots.some(
          (f) => feature.feature.properties.NY_ID === f.id
        )
          ? iconHighSmall
          : iconLowSmall;
      }

      //If future mode return icon based on season for selected future date
      const spot = props.filteredSpots.find(
        (f) => feature.feature.properties.NY_ID === f.id
      );
      if (!spot) return iconLowSmall;

      const season = getSpotSeason(spot, props.futureDate);
      return season === "high"
        ? iconHighSmall
        : season === "middle"
        ? iconMedium
        : iconLowSmall;
    }

    if (!context) return;
    layerRef.current.eachFeature((feature) => {
      feature.setIcon(getIcon(feature));
    });
  }, [props.filteredSpots, loaded]);

  useEffect(() => {
    const currentLayer = layerRef.current;
    if (!context) return;
    currentLayer.bindTooltip((layer) => layer.feature.properties.NAVN);
    currentLayer.addTo(context.map);

    const onLoad = () => {
      setLoaded(true);
    };
    currentLayer.on("load", onLoad);

    return () => {
      if (!context) return;
      layerRef.current.off("load", onLoad);
      context.map.removeLayer(currentLayer);
    };
  }, []);

  return null;
};

export default Fiskespots;
